
import { IParticipate } from "@common/models/Participate";
import { createContext } from "react";
import { IParticipateAction } from "./index";

export const ParticipateContext = createCtx<IParticipate, IParticipateAction>({});

export function createCtx<S, A>(defaultValue: S) {
    const defaultDispatch: React.Dispatch<A> = () => defaultValue;
    const ctx = createContext({
        participate: defaultValue,
        participateDispatch: defaultDispatch
    });
    return ctx;
}

